module.exports = __webpack_public_path__ + "static/media/RA-AP0005B_01.8f803412.png";